export default {
  /*
   * Devuelve los supports types (entities)
   */
  index(params) {
    return Vue.http.get('passenger/support_types', {params}).then(
      response => response.data.support_type
    )
  }
}
